<template>
  <div class="language-switch">
    <div class="language-options">
      <div class="language-option" 
           :class="{ 'active': currentLanguage === 'zh-CN' }"
           @click="handleLanguageChange('zh-CN')">
        中
      </div>
      <div class="language-separator">|</div>
      <div class="language-option" 
           :class="{ 'active': currentLanguage === 'en-US' }"
           @click="handleLanguageChange('en-US')">
        EN
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'

const { locale, t } = useI18n({ useScope: 'global' })
const currentLanguage = computed(() => locale.value)

const handleLanguageChange = (lang) => {
  if (currentLanguage.value !== lang) {
    locale.value = lang
    sessionStorage.setItem('language', lang)
    // 语言切换时重定向到首页，避免访问不存在的路径
    window.location.href = '/'
  }
}

onMounted(() => {
  // 初始化语言设置
  const savedLang = sessionStorage.getItem('language')
  if (savedLang) {
    locale.value = savedLang
  }
})
</script>

<style scoped>
.language-switch {
  position: relative;
  margin: auto 2vw;
  display: flex;
  align-items: center;
  z-index: 9999;
}

.language-options {
  display: flex;
  align-items: center;
  font-size: 32px;
  color: #1F2D3D;
  border-radius: 16px;
  /* border: 1px solid #4E5969; */
  overflow: hidden;
}

.language-option {
  padding: 8px 22px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.language-option:hover {
  color: #020814;
}

.language-option.active {
  font-weight: bold;
}

.language-separator {
  padding: 0 8px;
  color: #4E5969;
}

/* 移动端样式 */
@media (max-width: 768px) {
  .language-switch {
    margin-left: 200px;
    margin-right: 10px;
  }
  
  .language-options {
    font-size: 32px;
    border-radius: 8px;
  }
  
  .language-option {
    padding: 6px 12px;
  }
  
  .language-separator {
    padding: 0 4px;
  }
}
</style>